@import '../styles/fonts';
@import '../styles/palette';
@import '../styles/deviceBreakpoints';

.modal {
  width: fit-content;
  max-width: 80%;

  @include target(mobile) {
    min-width: 100%;
    width: 100%;
    max-height: fit-content;
    margin: 0;
  }

  @include target(mobile) {
    h1 {
      @include merriweather(18);
    }

    h2 {
      @include merriweather(14);
    }

    h3 {
      @include merriweather(12);
    }
  }

  h1 {
    @include merriweather(40, 600);
    color: _palette(secondary);

    @include target(mobile) {
      @include merriweather(20);
    }
  }

  h2 {
    @include merriweather(20);
    color: _palette(secondary);
  }

  h3 {
    @include merriweather(14);
    color: _palette(text);
  }

  .content {
    margin: auto;
    text-align: center;
  }

  p {
    margin: 1em auto;
  }

  .progress {
    margin: 2em auto 0;
  }

  img {
    display: block;
    margin: 1em auto;
  }

  .footer {
    flex-wrap: wrap;

    .buttonContainer {
      width: fit-content;
    }
  }

  .policy {
    text-align: left;
  }
}
